module.exports = __webpack_public_path__ + "img/service_progress_5.9f3d5f27.png";